import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import BranchForm from "../Forms/BranchForm";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles
import StateForms from "../Forms/StateForms";

export default function State() {
  const { setUserAccess, role } = useUser();
  const [permissionsData, setPermissionsData] = useState();
  const [tableData, setTableData] = useState();
  const [rowId, setRowId] = useState();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [permissionMassage, setPermissionMassage] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setRowId();
  };

  // Define columns with action column correctly structured
  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,

      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() => {
                fetchDataUserAccess("edit", true, params, "");
              }}
            >
              <TbEdit size={18} />
            </button>
            <button
              className="delete-btn"
              onClick={() => fetchDataUserAccess("delete", true, params, "")}
            >
              <RiDeleteBin6Line size={18} />
            </button>
          </div>
        </div>
      ),
    },
    { key: "state_name", label: "State", sortable: true },
    { key: "rate", label: "Rate", sortable: true },
  ];

  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        if (checkPermission(role, method, result.permission)) {
          if (showPopup) {
            if (method === "delete") {
              setOpen(true);
              setRowId(params.id);
            } else {
              setRowId(params.id);
              setShowModal(true);
            }
          } else {
            if (goToLink) navigate(goToLink);
          }
        } else {
          setPermissionMassage(true);
          toast.error("You don't have permission for this action!");
        }
      }
    } catch (error) {
      console.log("Error:", error);
      toast.error("Failed to fetch user access data.");
    }
  };

  const fetchData = async () => {
    setTableData([]);
    try {
      const result = await getData("/api/all-states");
      if (result.success) {
        setTableData(result.data);
        setPermissionsData(result.permission);
        if (!checkPermission("Branch", "view", result.permission)) {
          setPermissionMassage(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
          toast.error("You don't have permission to view this page!"); // Show error toast
        }
      } else {
        setPermissionsData(result?.permission);
      }
    } catch (error) {
      console.log("Error:", error);
      toast.error("Failed to fetch branch data."); // Show error toast
    }
  };

  const indexedRows =
    tableData?.length > 0 &&
    tableData?.map((data, index) => ({
      index: index + 1,
      id: data.id,
      state_name: data?.state_name,
      rate: data.rate,
    }));

  useEffect(() => {
    fetchData();
    setRowId(null);
  }, []);

  return (
    <div className="usa-prose">
      <TopHeading
        // heading="State"
        setShowModal={() => {
          fetchDataUserAccess("add", true, "", "");
        }}
        isHideBtn={true}
      />
      <CommonTable columns={columns} data={indexedRows || []} />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-state/${rowId}`}
          getApi={fetchData}
        />
      )}
      {showModal && (
        <CommonModal
          isOpen={showModal}
          onClose={handleClose}
          title={rowId ? "Edit State" : "Add State"}
        >
          <StateForms onClose={handleClose} id={rowId} fetchData={fetchData} />
        </CommonModal>
      )}
      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
    </div>
  );
}
